import React from "react";
import parse from "html-react-parser";
import "./html-parser.scss";

const ReactHtmlParser = ({ htmlString }) => {
  return <div className="html-parser">{parse(htmlString)}</div>;
};
export default ReactHtmlParser;
